import type { ReactNode } from "react";

export const inputClass =
  "w-full rounded-md border border-line bg-white px-4 py-3.5 text-sm text-ink placeholder:text-ink-soft/50 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition-colors";

export const textareaClass =
  "w-full rounded-md border border-line bg-white px-4 py-3.5 text-sm text-ink placeholder:text-ink-soft/50 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition-colors min-h-[120px] resize-y";

export const selectClass = inputClass;

export const submitButtonClass =
  "inline-flex items-center justify-center gap-2 rounded-md bg-primary px-7 py-3.5 text-base font-semibold text-white whitespace-nowrap cursor-pointer transition-colors duration-300 hover:bg-primary-dark disabled:opacity-60 disabled:cursor-not-allowed";

type FormFieldProps = {
  label: string;
  name: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
};

export default function FormField({
  label,
  required,
  error,
  children,
}: FormFieldProps) {
  return (
    <div>
      <label className="block">
        <span className="text-sm font-medium text-ink">
          {label}
          {required && <span className="text-gold"> *</span>}
        </span>
        <span className="mt-2 block">{children}</span>
      </label>
      {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
}